import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ScreenSizeStore } from '../../../stores/screen-size.store';
import { SettingStore } from '../../../stores/setting.store';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  imports: [RouterLink, TranslateModule],
})
export class FooterComponent {
  protected readonly settingStore = inject(SettingStore);
  protected readonly screenSizeStore = inject(ScreenSizeStore);
  protected readonly defaultLogoUrl = '/default-logo.png';

  readonly currentYear = new Date().getFullYear();
}
